/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import RightDetails from "./RightDetails";
import LeftNav from "./LeftNav";
import BannerSection from "../BannerSection";
import { useLocation, useNavigate } from "react-router-dom";

export default function DashBoardLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/signin");
    }
  }, []);
  const [perofileData, setProfileData] = useState("");
  return (
    <>
      <BannerSection />
      <section className="dashboard mt_100 xs_mt_70 mb_100 xs_mb_70">
        <div className="container">
          <div className="dashboard_area">
            <div className="row">
              <LeftNav
                perofileData={perofileData}
                setProfileData={setProfileData}
              />
              <RightDetails
                perofileData={perofileData}
                setProfileData={setProfileData}
                children={children}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
